<template>
	<settings-tabs-content />
</template>
<script>
import i18n from './dictionary';

// components
import SettingsTabsContent from '@/components/layout/appBar/appBarMenu/settingsTabs/settingsTabsContent/SettingsTabsContent.vue';
export default {
	name: `BasicDataManagement`,
	components: { SettingsTabsContent },
	i18n,
};
</script>
